import { Alert } from "antd";

export function StandardPasswordPolicyAlert(props: { className?: string }) {
  const { className } = props;
  const message = (
    <div className="text-xs">
      Passwords must be reset every <span className="font-bold">90 days</span>.
    </div>
  );
  return (
    <Alert
      message={message}
      type="info"
      className={`text-xs ${className || ""}`}
      showIcon
    />
  );
}

export function ExpiredPasswordPolicyAlert(props: { className?: string }) {
  const { className } = props;
  const message = (
    <div className="text-xs">
      Your password has expired. Passwords must be reset every{" "}
      <span className="font-bold">90 days</span>, as per our Security Policy.
    </div>
  );
  return (
    <Alert
      message={message}
      type="info"
      className={`text-xs ${className || ""}`}
      showIcon
    />
  );
}

export function PasswordFailedConditionsAlert(props: { className?: string }) {
  const { className } = props;
  const message = (
    <div className="text-sm">Password does not match the conditions.</div>
  );
  return (
    <Alert
      message={message}
      type="error"
      className={`text-xs ${className || ""}`}
      showIcon
    />
  );
}

export function LastPasswordMatchConditionsAlert(props: {
  className?: string;
}) {
  const { className } = props;
  const message = (
    <div className="text-sm">
      Password cannot be the same as any of your last 10 passwords.
    </div>
  );
  return (
    <Alert
      message={message}
      type="error"
      className={`rounded-lg text-xs ${className || ""}`}
      showIcon
    />
  );
}

function PasswordPolicy() {
  return (
    <div className="text-xs text-black text-opacity-80">
      <div className="space-y-1.5">
        <div className="font-bold">Criteria:</div>
        <div className="font-normal">
          <ul className="pl-8 space-y-1">
            <li className="leading-4">Minimum 12 characters</li>
            <li className="leading-4">1 Uppercase</li>
            <li className="leading-4">1 Lowercase</li>
            <li className="leading-4">1 Special Character</li>
            <li className="leading-4">
              Cannot be the same as the last 10 passwords.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default PasswordPolicy;
